export default "__VITE_ASSET__c94818bb__"